import { Ajax } from "../../Common/Ajax";
import { GlobalData } from "../../Common/GlobalData";
import { HtmlHelpers } from "../../Common/HtmlHelpers";
import { TemplateHelpers } from "../../Common/KendoHelpers";

export class BuyPointAnalysis {
    private static readonly REPORT_DATE = '#closingDate';
    private static readonly GRID = '#grid';

    constructor() {
        this.init();
    }

        private init() {
            $(BuyPointAnalysis.GRID).kendoGrid({
                dataSource: {
                    transport: {
                        read: GlobalData.URL_BASE +
                        GlobalData.URL_SUFFIX_IBD_LEADERBOARD_BUYPOINT_ANALYSIS
                    },
                },
                dataBound: () => {
                    var data: any = $(BuyPointAnalysis.GRID).data('kendoGrid')!.dataSource.data();
                    if (data && data.length > 0) {
                        $(BuyPointAnalysis.REPORT_DATE).html(
                            HtmlHelpers.getFormattedDate(data[0].closingDate));
                    }
                },

                height: 915,
                groupable: false,
                sortable: true,
                pageable: false,
                detailInit: this.openDetail,
                columns: [{
                    field: 'symbol',
                    title: 'Symbol',
                    width: '8%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                }, {
                    field: 'companyName',
                    title: 'Company Name',
                    width: '17%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12-left' },
                    attributes: { 'class': 'table-cell grid-cell-left' },
                }, {
                    field: 'listName',
                    title: 'List Name',
                    width: '12%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12-left' },
                    attributes: { 'class': 'table-cell grid-cell-left' },
                }, {
                    field: 'close',
                    title: 'Close',
                    width: '8%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                    format: '{0:c2}',
                }, {
                    field: 'buyPoint',
                    title: 'Buy Point',
                    width: '10%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                    format: '{0:c2}',
                }, {
                    field: 'nearBuyPoint',
                    title: 'Near<br>Buy Point',
                    width: '10%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                    template: kendo.template(TemplateHelpers.getBoolTemplate('nearBuyPoint')),
                }, {
                    field: 'inBuyZone',
                    title: 'In<br>Buy Zone',
                    width: '10%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                    template: kendo.template(TemplateHelpers.getBoolTemplate('inBuyZone')),
                }, {
                    field: 'extended',
                    title: 'Analysis<br>Extended',
                    width: '10%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                    template: kendo.template(this.getExtendedTemplate()),
                }, {
                    field: 'rank',
                    title: 'Rank',
                    width: '5%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                }, {
                    field: 'updateDate',
                    title: 'Update<br>Date',
                    width: '10%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-right' },
                    template: kendo.template(TemplateHelpers.getFormattedDateTemplate('updateDate')),
                }, {
                    field: 'closingDate',
                    hidden: true,
                }]
        });
    }
    private openDetail(e: any) {
        const urlSuffix = GlobalData.URL_SUFFIX_IBD_LEADERBOARD_BUYPOINT_ANALYSIS +
            '/Detail?symbol=' + e.data.symbol + '&listName=' + e.data.listName;

        const success = (data: any) => {
            if (e.detailCell != null) {
                e.detailCell.html(data);
            }
        };

        const error = () => {
            e.detailCell = null;
        }

        Ajax.invoke(urlSuffix, 'GET', null, success, error);
    }

    private getExtendedTemplate() {
        return '# if (extended) { #' +
            '<div>Extended</div>' +
            '# } else { #' +
            '<div></div>' +
            '# } #';
    }
}
